import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as en from '../../assets/i18n/en.json';
import * as hu from '../../assets/i18n/hu.json';

@Injectable()
export class LanguageService {
    private translateService = inject(TranslateService);

    constructor() {
        this.translateService.addLangs(['en', 'hu']);

        this.translateService.setTranslation('en', (en as any).default);
        this.translateService.setTranslation('hu', (hu as any).default);
        const browserLang = this.translateService.getBrowserLang() ?? 'en';

        this.translateService.setDefaultLang('en');
        this.setLanguage(this.translateService.getLangs().indexOf(browserLang) > -1 ? browserLang : 'en');
    }

    setLanguage(isoCode?: any) {
        if (!isoCode) {
            isoCode = 'en';
        }

        isoCode = isoCode.toLowerCase();

        this.translateService.use(isoCode);
    }

    getCurrentLanguage() {
        return this.translateService.currentLang;
    }

}
